import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectNotesList } from '../project-notes-list/project-notes-list';
import { ProjectNotesStoreService } from 'src/app/project-display/data-access/project-notes-store-service';
import { CreateMemberNoteDialogComponent } from '../member-note-dialogs/create-member-note-dialog/create-member-note-dialog.component';
import { IProjectNote } from 'src/app/project-display/interfaces/IProjectNote';

interface INoteType {
  caption: string;
  name: string;
  value: string;
  selected: boolean;
}

@Component({
  selector: 'eic-project-notes-header',
  templateUrl: './project-notes-header.html',
  styleUrl: './project-notes-header.scss'
})
export class ProjectNotesHeader {
  @Output() selectedNoteTypes_change: EventEmitter<number[]> = new EventEmitter();
  @Input() projectNotesList: ProjectNotesList;
  @Input() projectId: number;
  @Input() showMemberNoteControls: boolean;

  options = [
    { caption: "Contract Activity", name: "contractActivity", value: "1", selected: true },
    { caption: "Development", name: "developmentNews", value: "2", selected: true },
    { caption: "Planning", name: "planningNews", value: "3", selected: true },
    { caption: "Financial", name: "financialNew", value: "4", selected: true },
    { caption: "General", name: "generalNews", value: "5", selected: true },
    { caption: "Member Notes", name: "MemberNotes", value: "6", selected: true }
  ];


  constructor(
    public projectNotesStore: ProjectNotesStoreService,
    private dialog: MatDialog
  ) { }


  selectedValuesChanged(changeParams) {
    this.options[changeParams.index].selected = changeParams.checked
    this.emitSelectedNoteTypes(this.options);
  }


  emitSelectedNoteTypes(options?: INoteType[]) {
    // if no options are provided, this means no
    // note types wer selected, so emit an empty array
    let selectedNoteTypes: number[] = [];

    if (options) {
      selectedNoteTypes = options
        .filter(o => o.selected)
        .map(o => +o.value);
    }

    this.projectNotesStore.selectedNoteTypes = selectedNoteTypes;
  }


  selectNone() {
    this.options.forEach(o => {
      o.selected = false;
    });

    this.emitSelectedNoteTypes();
  }


  selectAll() {
    this.options.forEach(o => {
      o.selected = true;
    });

    this.emitSelectedNoteTypes(this.options);
  }


  openCreateMemberNoteDialog() {
    if (!this.projectId || !this.showMemberNoteControls) {
      return;
    }

    const dialogRef = this.dialog.open(CreateMemberNoteDialogComponent, {
      width: '600px',
      data: {
        projectID: this.projectId
      }
    });

    dialogRef.afterClosed().subscribe((newMemberNote: IProjectNote | undefined) => {
      if (!newMemberNote) {
        return;
      }

      this.projectNotesStore.addMemberNote(newMemberNote);
    });
  }


}
